var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rir-drag-upload-file',{attrs:{"count-file":0,"count-line":2,"upload-url":_vm.$root.$uploadServer,"params-body":{
    code: 'PREVENTION',
    type: '08-02'
  },"accept-file":['.jpg', '.jpeg', '.png']},model:{value:(_vm.attachmentsFinish),callback:function ($$v) {_vm.attachmentsFinish=$$v},expression:"attachmentsFinish"}})}
var staticRenderFns = []

export { render, staticRenderFns }